import React , {Component} from 'react';
import ReactDOM from 'react-dom';

import './index.css';

import CommentInput from './CommentInput';
import CommentList from './CommentList';

class CommentApp extends Component{
  constructor(){
    super();
    this.state = {
      comments : []
    }
  }
  handleSendValue(comment){
    if(!comment.username) return alert("请输入用户名");
    if(!comment.content){
      alert("请输入评论内容");
      return;
    };
    this.state.comments.push(comment);
    this.setState({
      comments:this.state.comments
    })
  }
  render(){
    return(
      <div className="wrap">
        <CommentInput onSubmit={this.handleSendValue.bind(this)}/>
        <CommentList comments={this.state.comments}/>
      </div>
    )
  }
}



ReactDOM.render(
  <CommentApp />,
  document.getElementById('root')
);



// WEBPACK FOOTER //
// ./src/index.js